import confetti from "canvas-confetti";

export { confetti };

export function defaultConfettiFire(defaults = {}) {
  const defaultOptions = Object.assign(
    {
      particleCount: 400,
      zIndex: Number.MAX_SAFE_INTEGER,
      origin: { y: 0.5 },
    },
    defaults,
  );
  const fire = (particleRatio, options) =>
    confetti(
      Object.assign(defaultOptions, options, {
        particleCount: Math.floor(defaultOptions.particleCount * particleRatio),
      }),
    );

  fire(0.25, { spread: 26, startVelocity: 55 });
  fire(0.2, { spread: 60 });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
  fire(0.1, { spread: 120, startVelocity: 45 });
}
